import { createSlice } from "@reduxjs/toolkit";
import { doc, setDoc, getFirestore } from "firebase/firestore";
import app from "./firebaseinit";

const usersDb = "users";
const db = getFirestore(app);
/* eslint-disable no-param-reassign */
export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    uid: "",
    currentUser: {},
    profile: {},
    error: {},
  },
  reducers: {
    handleLoginUser: (state, action) => {
      state.isAuthenticated = false;
      state.currentUser = {};
      state.profile = {};
      state.uid = "";
      localStorage.setItem("user", JSON.stringify(action.payload));
      state.currentUser = action.payload;
      state.isAuthenticated = true;
      state.uid = state.currentUser.uid;
    },
    getUserData: (state, action) => {
      state.isAuthenticated = false;
      state.currentUser = {};
      state.profile = {};
      state.uid = "";
      const user = JSON.parse(localStorage.getItem("user"));
      if (user !== null && user !== "") {
        console.log(action.payload);
        // console.log(user.uid);
        state.currentUser = user;
        state.uid = user.uid;
        state.isAuthenticated = true;
      } else {
        state.currentUser = {};
        state.uid = "";
        state.isAuthenticated = false;
      }
    },
    updateUserProfile: (state, action) => {
      state.profile = action.payload;
      try {
        setDoc(doc(db, usersDb, state.uid), {
          linkedinusername: state.profile.linkedinusername,
          githubusername: state.profile.githubusername,
          uid: state.currentUser.uid,
          email: state.currentUser.email,
          name: state.currentUser?.displayName,
        });
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    },
    getProfileData: (state, action) => {
      state.profile = action.payload;
      console.log("called");
    },
    logOut: (state, action) => {
      state.isAuthenticated = false;
      state.currentUser = action.payload;
      state.profile = action.payload;
      state.uid = undefined;

      localStorage.clear();
    }
  }
});

export const { handleLoginUser, getUserData, updateUserProfile, getProfileData, logOut } = authSlice.actions;

export default authSlice.reducer;
